import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { Modal } from 'synfrastructure';
import { withRouter } from 'react-router-dom';
import { formatValidationErrors } from '../../common/utils/getApiReducer';
import {
  cancelBookedSession,
  editFollowUpData,
  getFollowUpData,
  getTathataFollowUps,
  respondToFollowUpRequest,
} from '../redux/actions';
import { selectNewSessions, selectBookedSessions, selectCompletedSessions } from '../redux/selectors';
import Icon from '../../common/icons/Icon';
import Loading from '../../common/components/Loading';
import FollowUpEditAvailabilityForm from './FollowUpEditAvailabilityForm';
import FollowUpList from '../common/FollowUpList';
import NewSessionModal from './NewSessionModal';
import BookedSessionModal from './BookedSessionModal';

class FollowUpsHome extends Component {
  state = {
    editingAvailability: false,
    newSessionModalVisible: false,
    bookedSessionModalVisible: false,
  };

  componentDidMount() {
    this.props.dispatch(getFollowUpData());
    this.props.dispatch(getTathataFollowUps());
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.respondToFollowUpRequest.get('loading') && nextProps.respondToFollowUpRequest.get('loaded')) {
      this.toggleNewSessionModal(null);
    }

    if (this.props.cancelSession.get('loading') && nextProps.cancelSession.get('loaded')) {
      this.toggleBookedSessionModal(null);
    }
  }

  toggleEdit = () => {
    this.setState(state => ({
      editingAvailability: !state.editingAvailability,
    }));
  };

  updateFollowUpAvailability = values => {
    const { dispatch } = this.props;

    return dispatch(editFollowUpData(values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.setState({ editingAvailability: false });
      }
    });
  };

  toggleNewSessionModal = session => {
    this.setState(state => ({
      modalActiveSession: session,
      newSessionModalVisible: !state.newSessionModalVisible,
    }));
  };

  toggleBookedSessionModal = session => {
    this.setState(state => ({
      modalActiveSession: session,
      bookedSessionModalVisible: !state.bookedSessionModalVisible,
    }));
  };

  showHistory = () => {
    this.props.history.push(`${this.props.match.path}history`);
  };

  onSessionAccept = values => {
    const session = this.state.modalActiveSession;
    const payloadValues = {
      acceptedSessionDate: values.acceptedSessionDate,
      responseNote: values.responseNote,
      status: 'accepted',
    };

    this.props.dispatch(respondToFollowUpRequest(session.id, payloadValues));
  };

  onSessionReject = values => {
    const session = this.state.modalActiveSession;
    const payloadValues = {
      responseNote: values.responseNote,
      status: 'rejected',
    };

    this.props.dispatch(respondToFollowUpRequest(session.id, payloadValues));
  };

  onSessionCancel = values => {
    const session = this.state.modalActiveSession;
    const payloadValues = {
      cancelNote: values.cancelNote,
    };

    this.props.dispatch(cancelBookedSession(session.movement_specialist_user_id, session.id, payloadValues));
  };

  render() {
    const {
      followUpData,
      loaded,
      newSessions,
      bookedSessions,
      cancelSession,
      completedSessions,
      respondToFollowUpRequest,
    } = this.props;
    const { editingAvailability, modalActiveSession, bookedSessionModalVisible, newSessionModalVisible } = this.state;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <div className="admin-paper admin--follow-ups">
        {newSessionModalVisible && (
          <Modal
            isVisible
            onClose={this.toggleNewSessionModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <NewSessionModal
              onAccept={this.onSessionAccept}
              onReject={this.onSessionReject}
              loading={respondToFollowUpRequest.get('loading')}
              session={modalActiveSession}
              toggleModal={this.toggleNewSessionModal}
            />
          </Modal>
        )}
        {bookedSessionModalVisible && (
          <Modal
            isVisible
            onClose={this.toggleBookedSessionModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <BookedSessionModal
              onCancel={this.onSessionCancel}
              loading={cancelSession.get('loading')}
              session={modalActiveSession}
              toggleModal={this.toggleBookedSessionModal}
            />
          </Modal>
        )}
        <div className="admin-paper__header">
          <h3>Follow-Ups</h3>
        </div>
        <div className="admin-paper__edit-content">
          <h4>Availability Details</h4>
          {editingAvailability ? (
            <FollowUpEditAvailabilityForm
              initialValues={{ availability: followUpData.getIn(['data', 'availability']) }}
              onCancel={this.toggleEdit}
              onSubmit={this.updateFollowUpAvailability}
            />
          ) : (
            <div>
              <div className="admin-paper__edit-content__row">
                <p>Availability</p>
                <span className="title">{followUpData.getIn(['data', 'availability'])}</span>
              </div>
              <div className="admin-paper__edit-button">
                <button className="button" onClick={this.toggleEdit}>
                  Edit
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="ms-admin__sessions">
          <FollowUpList
            headerTitle="New"
            icon="Envelope"
            onItemView={this.toggleNewSessionModal}
            sessions={newSessions}
            type="new"
          />
          <FollowUpList
            headerTitle="Booked"
            icon="Calendar"
            onItemView={this.toggleBookedSessionModal}
            sessions={bookedSessions}
            type="booked"
          />
          <FollowUpList
            completing={false}
            headerTitle="Completed"
            icon="CheckmarkCircle"
            onItemView={this.toggleBookedSessionModal}
            sessions={completedSessions}
            showHistory={this.showHistory}
            type="completed"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const completed = selectCompletedSessions(state);
  return {
    bookedSessions: selectBookedSessions(state),
    cancelSession: state.followUps.cancelSession,
    completedSessions: completed && completed.length > 5 ? completed.slice(0, 5) : completed,
    editFollowUpData: state.followUps.editFollowUpData,
    followUpData: state.followUps.followUpData,
    loaded: state.followUps.followUps.get('loaded') && state.followUps.followUpData.get('loaded'),
    newSessions: selectNewSessions(state),
    respondToFollowUpRequest: state.followUps.respondToFollowUpRequest,
  };
};

export default withRouter(connect(mapStateToProps)(FollowUpsHome));



// WEBPACK FOOTER //
// ./src/follow-ups/home/FollowUpsHome.js